import React, { useEffect, useState } from 'react';
import Hero from '../components/Hero';
import RecentWork from '../components/RecentWork';
import { useLang } from '../context/LanguageContext';
import { getProfile, getWorks } from '../api';

export default function Home() {
  const { t } = useLang();
  const [profile, setProfile] = useState(null);
  const [works, setWorks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [profileRes, worksRes] = await Promise.allSettled([
          getProfile(),
          getWorks(),
        ]);

        if (profileRes.status === 'fulfilled') {
          setProfile(profileRes.value.data);
        }

        if (worksRes.status === 'fulfilled') {
          setWorks(worksRes.value.data);
        }

        const failedRequests = [profileRes, worksRes].filter(
          (result) => result.status === 'rejected'
        );

        if (failedRequests.length > 0) {
          setLoadError('部分内容暂时没有加载成功，但网站主体仍可继续访问。');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoadError('网站内容加载失败，请稍后刷新重试。');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-dark flex items-center justify-center">
        <div className="text-white text-xl">{t.loading}</div>
      </div>
    );
  }

  return (
    <div className="bg-dark">
      {loadError && (
        <div className="mx-auto max-w-7xl px-6 pt-6 lg:px-8">
          <div className="rounded-xl border border-amber-700 bg-amber-950/40 px-4 py-3 text-sm text-amber-100">
            {loadError}
          </div>
        </div>
      )}
      <Hero profile={profile} />
      <RecentWork works={works} />
    </div>
  );
}
